module.exports = __webpack_public_path__ + "img/1480825306.b4049eee.jpg";